import React from 'react';
import Typography from '@mui/material/Typography';

function getPercentage(given_score, total_score) {
    const percentage = (given_score / total_score) * 100;
    return percentage.toFixed(0);
}

const SubmissionScoreSummary = ({
    correctAnswerCount,
    autoGradedTotal,
    gradedCount,
    totalQuestionCount,
    nonAutoGradedTotalScore,
    nonAutoGradedGivenScore,
    colors,
}) => {
    return (
        <>
            {/* Grading progress */}
            {totalQuestionCount > 0 && (
                <Typography variant="h6" ml={2} color={
                    gradedCount === totalQuestionCount ? 'success.main' : 'text.secondary'
                }>
                    {gradedCount === totalQuestionCount
                        ? `All ${totalQuestionCount} ${totalQuestionCount === 1 ? 'question' : 'questions'} graded`
                        : `${gradedCount} / ${totalQuestionCount} ${totalQuestionCount === 1 ? 'question' : 'questions'} graded`
                    }
                </Typography>
            )}

            {/* Auto-graded score */}
            {correctAnswerCount !== null && autoGradedTotal > 0 && (
                <Typography variant="h6" fontWeight="bold" ml={2}>
                    - Score: {correctAnswerCount} / {autoGradedTotal}
                </Typography>
            )}

            {/* Non-auto-graded score (essay/file questions) */}
            {nonAutoGradedTotalScore > 0 && (
                <Typography variant="h6" fontWeight="bold" ml={2}>
                    - Score: {getPercentage(nonAutoGradedGivenScore, nonAutoGradedTotalScore)}%
                    <span style={{ color: colors.grey[700], fontWeight: 'normal' }}> (score for essay/file questions)</span>
                </Typography>
            )}
        </>
    );
};

export default SubmissionScoreSummary;
